import { apiGet, apiPost, apiDelete } from './client';

export interface Favorite {
  id: string;
  event: any;
  createdAt: string;
}

export interface FavoritesResponse {
  success: boolean;
  message: string;
  data: {
    favorites: Favorite[];
  };
}

export interface FavoriteResponse {
  success: boolean;
  message: string;
  data: {
    favorite: Favorite;
  };
}

export interface CheckFavoriteResponse {
  success: boolean;
  message: string;
  data: {
    isFavorited: boolean;
  };
}

export const favoritesApi = {
  // Get user's favorites
  getFavorites: (): Promise<FavoritesResponse> => {
    return apiGet('/favorites');
  },

  // Add event to favorites
  addFavorite: (eventId: string): Promise<FavoriteResponse> => {
    return apiPost('/favorites', { eventId });
  },

  // Remove event from favorites
  removeFavorite: (eventId: string): Promise<any> => {
    return apiDelete(`/favorites/${eventId}`);
  },

  // Check if event is favorited
  checkFavorite: (eventId: string): Promise<CheckFavoriteResponse> => {
    return apiGet(`/favorites/check/${eventId}`);
  },
};




